import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales November 2025 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) retroactive to 1/1/2025
const jobData = [
  {
    jobInfo: "E-687: Dominika Gergely",
    leadSource: "Referral- Cody's network",
    trade: "Solar",
    contractTotal: 3000.00,
    grossMarginPct: 0.6650,
    grossProfit: 1995.00,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 3000.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-721: Lauren Maxwell",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 6590.00,
    grossMarginPct: 0.5382,
    grossProfit: 3546.74,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6590.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-683: Pennrose Management Oak Liberty Property",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 3125.50,
    grossMarginPct: 0.4348,
    grossProfit: 1358.97,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3125.50 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-728: Brad Norman",
    leadSource: "Referral- Dominic's network",
    trade: "Gutters",
    contractTotal: 550.00,
    grossMarginPct: 0.4545,
    grossProfit: 249.98,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 550.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-716: Tyler Scarff",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 6094.00,
    grossMarginPct: 0.4871,
    grossProfit: 2968.39,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6094.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-698: Solar Solution LLC",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 1554.55,
    grossMarginPct: 0.4601,
    grossProfit: 715.25,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1554.55 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-715: Carl & Bonnie Sink",
    leadSource: "Referral- Dominic's network",
    trade: "Gutters",
    contractTotal: 4780.00,
    grossMarginPct: 0.3331,
    grossProfit: 1592.22,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4780.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-714: John Tabor Binkley-Chalk C/O",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 3050.80,
    grossMarginPct: 0.4413,
    grossProfit: 1346.32,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3050.80 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-686: Aion Mariners Pointe",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 29445.00,
    grossMarginPct: 0.4833,
    grossProfit: 14230.77,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 29445.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-726: Sandra Matia",
    leadSource: "Referral- Dominic's network",
    trade: "Other",
    contractTotal: 17896.63,
    grossMarginPct: 0.4982,
    grossProfit: 8916.10,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 17896.63 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-708: Julie Jones",
    leadSource: "Referral- Cody's network",
    trade: "Painting & Others",
    contractTotal: 16164.00,
    grossMarginPct: 0.6387,
    grossProfit: 10323.95,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 16164.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-711: Anna Scarbro",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 14166.67,
    grossMarginPct: 0.3940,
    grossProfit: 5581.67,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 14166.67 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-697: Marina Lyonsberg",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 2700.00,
    grossMarginPct: 0.1188,
    grossProfit: 320.76,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2700.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-704: Karissa Kovner",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 6498.63,
    grossMarginPct: 0.7414,
    grossProfit: 4818.08,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6498.63 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-725: Walid Kraydi",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 15418.18,
    grossMarginPct: 0.5620,
    grossProfit: 8665.02,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 15418.18 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-3346: Humanim Inc",
    leadSource: "Site Survey Website",
    trade: "Solar",
    contractTotal: 36172.00,
    grossMarginPct: 0.3000,
    grossProfit: 10851.60,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 36172.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-3348: Humanim Inc",
    leadSource: "Site Survey Website",
    trade: "Solar",
    contractTotal: 34971.00,
    grossMarginPct: 0.3000,
    grossProfit: 10491.30,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 34971.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "S-3347: Humanim Inc",
    leadSource: "Site Survey Website",
    trade: "Solar",
    contractTotal: 38842.00,
    grossMarginPct: 0.3000,
    grossProfit: 11652.60,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 38842.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-706: John Tabor Horowitz Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 54936.00,
    grossMarginPct: 0.3000,
    grossProfit: 16480.80,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 54936.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-702: Nicholas Vallerani",
    leadSource: "Previous Customer",
    trade: "Painting & Others",
    contractTotal: 3029.27,
    grossMarginPct: 0.6534,
    grossProfit: 1979.33,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3029.27 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-719: Thornhill Properties Tralee",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 21920.00,
    grossMarginPct: 0.4316,
    grossProfit: 9460.67,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 21920.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-718: Ballard Green Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 836.00,
    grossMarginPct: 0.3653,
    grossProfit: 305.39,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 836.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-709: Pennrose Management Obery",
    leadSource: "Referral- Cody's network",
    trade: "Painting & Others",
    contractTotal: 12395.00,
    grossMarginPct: 0.5321,
    grossProfit: 6595.38,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 12395.00 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesNovemberData: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // No manager fees in Cody structure
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Site Survey Website", spend: 0 },
    { source: "Previous Customer", spend: 0 },
    { source: "Google Organic Search", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 11,
    year: 2025
  }
};
